import IconClose from '!raw-loader!./assets/icon-close.svg';
import IconAngleDown from '!raw-loader!./assets/icon-angle-down.svg';
import IconWarning from '!raw-loader!./assets/icon-warning.svg';
import IconGlass from '!raw-loader!./assets/icon-glass.svg';
import IconAngleRight from '!raw-loader!./assets/icon-angle-right.svg';
import IconAngleLeft from '!raw-loader!./assets/icon-angle-left.svg';
import IconAngleTop from '!raw-loader!./assets/icon-angle-top.svg';
import IconCopy from '!raw-loader!./assets/icon-copy.svg';
import IconCheckmark from '!raw-loader!./assets/icon-checkmark.svg';

export enum ICON_NAME {
    CLOSE = 'close',
    ANGLE_DOWN = 'angle-down',
    WARNING = 'warning',
    GLASS = 'glass',
    ANGLE_RIGHT = 'angle-right',
    ANGLE_LEFT = 'angle-left',
    ANGLE_TOP = 'angle-top',
    COPY = 'copy',
    CHEKCMARK = 'checkmark',
}

export const ICON_NAME_TO_ICON_MAP: { [icon: string]: string } = {
    [ICON_NAME.CLOSE]: IconClose,
    [ICON_NAME.ANGLE_DOWN]: IconAngleDown,
    [ICON_NAME.WARNING]: IconWarning,
    [ICON_NAME.GLASS]: IconGlass,
    [ICON_NAME.ANGLE_RIGHT]: IconAngleRight,
    [ICON_NAME.ANGLE_LEFT]: IconAngleLeft,
    [ICON_NAME.ANGLE_TOP]: IconAngleTop,
    [ICON_NAME.COPY]: IconCopy,
    [ICON_NAME.CHEKCMARK]: IconCheckmark,
};
